import { useCallback, useContext } from 'react'
import { defineMessages, useIntl } from 'react-intl'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import ModalContext from 'contexts/ModalContext'
import { selectLoggedIn } from 'selectors/accountSelectors'
import AccountAccessModal from 'components/Account/AccountAccess/AccountAccessModal'
import LoyaltyJoinModal from 'loyalty/components/LoyaltyJoinModal'
import enrolLoyaltyAccount from 'actions/loyalty/enrolLoyaltyAccount'

/**
 * Shared "Join Société for free" button copy. Used by the join-Société flow itself and reused by the
 * surfaces that offer it (renewal bonus modal, reactivation success screen) so the CTA never drifts.
 */
export const joinSocieteMessages = defineMessages({
  cta: {
    id: 'qSHLLz7Fi2nt6ie1HCWT',
    defaultMessage: 'Join Société for free',
    description: 'Shared button/CTA label for joining the free Société loyalty program, reused across LuxPlus+ renewal surfaces',
  },
})

/**
 * Returns a callback that starts the existing join-Société flow: logged-out users sign in first,
 * logged-in non-members open the loyalty join modal and, on confirmation, enrol. Mirrors the other
 * "Join Société" CTAs (e.g. LoyaltyPurchasePointsNeedsMembershipCta).
 */
export default function useJoinSociete() {
  const intl = useIntl()
  const dispatch = useAppDispatch()
  const showModal = useContext(ModalContext)
  const isLoggedIn = useAppSelector(selectLoggedIn)

  return useCallback(async() => {
    if (!isLoggedIn) {
      showModal(<AccountAccessModal />)
      return
    }
    const joinConfirmed = await showModal<boolean>(
      <LoyaltyJoinModal onAfterClose={() => {}} primaryActionCta={intl.formatMessage(joinSocieteMessages.cta)} />,
    )
    if (joinConfirmed) {
      dispatch(enrolLoyaltyAccount({ enrolment: 'existingUserRegistration' }))
    }
  }, [isLoggedIn, showModal, dispatch, intl])
}
